import { backendProtocol, backendHost, backendPort } from '../endpoints.js';

export const HELPDESK = backendProtocol + backendHost + backendPort + '/api/helpdesk';
export const SAVE_FORM = HELPDESK + '/saveForm'
export const UPDATE_FORM_STATUS = HELPDESK + '/updateFormStatus'
export const FILTER_FORMS = HELPDESK + '/filterForms'
export const GET_FORM_OPTIONS = HELPDESK + '/getFormOptions'
export const GET_FORM_DETAILS = HELPDESK + '/getFormDetails'
export const GET_FORM_SCHEMA = HELPDESK + '/getFormSchema'
export const SAVE_INTERACTION_CATEGORY = HELPDESK + '/saveInteractionCategory'
export const FILTER_INTERACTION_CATEGORIES = HELPDESK + '/filterInteractionCategories'
export const GET_PARENT_INTERACTION_CATEGORIES = HELPDESK + '/getParentInteractionCategories'
export const GET_INTERACTION_CATEGORIES = HELPDESK + '/getInteractionCategories'
export const GET_CHANNELS = HELPDESK + '/getChannels'
export const GET_CONTACTS = HELPDESK + '/getContacts'
export const GET_INTERACTION_CATEGORY = HELPDESK + '/getInteractionCategory'
export const SAVE_INTERACTION = HELPDESK + '/saveInteraction'
export const FILTER_INTERACTIONS = HELPDESK + '/filterInteractions'
export const GET_INTERACTION = HELPDESK + '/getInteraction'
export const UPDATE_CHANNEL_STATUS = HELPDESK + '/updateChannelStatus'
export const FILTER_CHANNELS = HELPDESK + '/filterChannels'
export const FILTER_TICKET_TYPES = HELPDESK + '/filterTicketTypes'
export const SAVE_TICKET_TYPE = HELPDESK + '/saveTicketType'
export const GET_TICKET_TYPE = HELPDESK + '/getTicketType'
export const FILTER_TICKETS = HELPDESK + '/filterTickets'
export const SAVE_TICKET = HELPDESK + '/saveTicket'
export const SAVE_TICKET_ACTION = HELPDESK + '/saveTicketAction'
export const GET_TICKET = HELPDESK + '/getTicket'
export const SEND_CHATBOT_MESSAGE = HELPDESK + '/chatbot/message'
export const START_CHAT_CONVERSATION = HELPDESK + '/chat/startConversation'
export const SEND_CHAT_MESSAGE = HELPDESK + '/chat/sendMessage'
export const GET_CHAT_CONVERSATION = HELPDESK + '/chat/getConversation'
export const FILTER_CHAT_CONVERSATIONS = HELPDESK + '/chat/filterConversations'
export const GET_OFFICER_CHAT_CONVERSATION = HELPDESK + '/chat/getOfficerConversation'
export const REPLY_CHAT_CONVERSATION = HELPDESK + '/chat/reply'
export const CLOSE_CHAT_CONVERSATION = HELPDESK + '/chat/closeConversation'
export const CREATE_CHAT_TICKET = HELPDESK + '/chat/createTicket'
export const SAVE_CONTACT = HELPDESK + '/saveContact'
export const GET_CONTACT = HELPDESK + '/getContact'
export const GET_CUSTOMERS = HELPDESK + '/getContacts'
export const FILTER_CONTACTS = HELPDESK + '/filterContacts'

// REGISTRATION INTEGRATION
const REGISTRATION = backendProtocol + backendHost + backendPort + '/api/registration';
export const GET_PROCURING_ENTITIES = REGISTRATION + '/get-procuring-entities'
export const GET_SUPPLIERS = REGISTRATION + '/get-suppliers'
